// Assets
import {MdOutlineCameraAlt, MdOutlineCloudUpload} from "react-icons/md";
import DropZonefile from "./DropZonefile";
import React, {useState} from "react";
import {useDropzone} from "react-dropzone";

const Media = () => {

    const TARGET_HEIGHT = 80
    const TARGET_WIDTH = 80

    let [selectedFile, setSelectedFile] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    // Convert the image to base64
    function toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    const getImageResolution = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Read image data as URL

            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    resolve({width, height}); // Return resolution

                    URL.revokeObjectURL(img.src); // Revoke temporary URL
                };

                img.onerror = (error) => {
                    reject(error); // Handle image loading error
                };
            };

            reader.onerror = (error) => {
                reject(error); // Handle file reading error
            };
        });
    };

    const onDrop = async acceptedFiles => {
        //console.log("Inside")
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            //console.log("Inside")
            //console.log(file.type)

            // Check for valid image types (optional)
            const validImageTypes = ['image/jpeg', 'image/png'];
            if (!validImageTypes.includes(file.type)) {
                //console.error('Invalid image type. Please upload a JPEG or PNG file.');
                setErrorMessage('Invalid image type. Please upload a JPEG or PNG file.')
                return;
            }

            // Check for size limit (optional)
            if (file.size > 1048576) {  // 1 MB
                setErrorMessage('Image size exceeds 1 MB limit.')
                //console.error('Image size exceeds 1 MB limit.');
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file); // Read image as data URL

            reader.onload = (e) => {
                const dataURL = e.target.result;
                const filename = file.name;

                // Store filename and dataURL in session storage
                sessionStorage.setItem('uploadedImageFilename', filename);
                sessionStorage.setItem('uploadedImageFile', dataURL);
            };

            getImageResolution(file)
                .then(async (resolution) => {
                    //console.log(`Image resolution: ${resolution.width} x ${resolution.height}`);

                    if (resolution.width === TARGET_WIDTH && resolution.height === TARGET_HEIGHT) {
                        setErrorMessage("")
                        setSelectedFile(file);
                        selectedFile = file


                        const base64String = await toBase64(file);
                        sessionStorage.setItem("updatedProductImage", base64String);
                        sessionStorage.setItem("updatedProductImageName", file.name);
                    } else {
                        setErrorMessage("Please upload file of 80*80 dimensions")
                    }

                })
                .catch((error) => {
                    console.error('Error getting image resolution:', error);
                });

        }
    };

    const filename = sessionStorage.getItem("uploadedImageFilename");
    const dataURL = sessionStorage.getItem("uploadedImageFile");

    //console.log(sessionStorage.getItem('uploadedImageFile'))
    //console.log(filename)

    if (filename !== "" && dataURL !== "") {
        if (document.getElementById('productImage') !== null) {
            const imageElement = document.getElementById('productImage');
            //console.log(dataURL)
            imageElement.src = dataURL;
            imageElement.alt = filename; // Set alt text for accessibility
        }

        /*setSelectedFile(dataURL)*/
    }

    const {getRootProps, getInputProps} = useDropzone({onDrop});

    return (
        <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
            {/* Header */}
            <h4 className="mb-6 pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
                Product Image <span className="font-normal">(Optional)</span>
            </h4>
            <span className="errorMessage items-center flex justify-content: center align-items: center flex-col">
                {errorMessage}
            </span>
            {/* content */}
            <div className="flex w-full items-center justify-center rounded-[20px]">
                <div
                    className="flex h-full !w-[700px] cursor-pointer items-center justify-center rounded-xl border-dashed border-navy-700"
                    {...getRootProps()}>
                    {
                        !selectedFile && (
                            <button className="h-full !w-full">
                                <input {...getInputProps()}  />
                                <div
                                    className="flex h-[225px] w-full flex-col items-center justify-center rounded-xl border-[1px] border-dashed border-gray-200 bg-gray-100 dark:!border-none dark:!bg-navy-700 sm:w-[400px] md:w-[570px] lg:w-[700px] xl:w-[600px] 2xl:w-[690px] 3xl:w-[680px]">
                                    <p className="text-[80px] text-navy-700">
                                        <MdOutlineCloudUpload className="text-[#004c86] dark:text-white"/>
                                    </p>
                                    <p className="text-lg font-bold text-navy-700 dark:text-white">
                                        Drop your files here, or{" "}
                                        <span className="font-bold text-[#004c86] dark:text-[#0b83b5]">
                                    browse
                                </span>
                                    </p>
                                    <p className="pt-2 text-sm text-gray-600">
                                        PNG and JPG files are allowed. Upload an image of 80*80 pixels.
                                    </p>
                                </div>
                            </button>
                        )
                    }
                    {
                        selectedFile && (
                            <div
                                className="h-full !w-full items-center flex justify-content: center align-items: center flex-col">
                                <img id="productImage" src={URL.createObjectURL(selectedFile)}
                                     className="flex h-[225px] w-full flex-col items-center justify-center
                           rounded-xl border-[1px] border-dashed border-gray-200
                            bg-gray-100 dark:!border-none dark:!bg-navy-700 sm:w-[400px] md:w-[570px]
                            lg:w-fit xl:w-fit 2xl:w-fit 3xl:w-fit"
                                     alt="Uploaded preview"/>
                                {selectedFile && (
                                    <p className="text-sm text-gray-600 mt-2">
                                        <span className="font-bold">
                                            Uploaded file:
                                        </span>
                                        <span className="font-semibold text-[#004c86]">
                                            {selectedFile.name}
                                        </span>
                                    </p>
                                )}
                                <p className="pt-2 text-sm text-gray-600">
                                    PNG and JPG files are allowed. Upload an image of 80*80 pixels.
                                </p>
                                <p className="pt-2 text-sm font-bold text-[#004c86]">
                                    Change image
                                    <input {...getInputProps()}  />
                                </p>
                            </div>
                        )
                    }
                </div>
                {/*<DropZonefile
                    content={
                        <div
                            className="flex h-[225px] w-full flex-col items-center justify-center rounded-xl border-[1px] border-dashed border-gray-200 bg-gray-100 dark:!border-none dark:!bg-navy-700 sm:w-[400px] md:w-[570px] lg:w-[700px] xl:w-[600px] 2xl:w-[690px] 3xl:w-[680px]">
                            <p className="text-[80px] text-navy-700">
                                <MdOutlineCloudUpload className="text-[#004c86] dark:text-white"/>
                            </p>
                            <p className="text-lg font-bold text-navy-700 dark:text-white">
                                Drop your files here, or{" "}
                                <span className="font-bold text-[#004c86] dark:text-[#0b83b5]">
                  browse
                </span>
                            </p>
                            <p className="pt-2 text-sm text-gray-600">
                                PNG and JPG files are allowed. Upload an image of 80*80 pixels.
                            </p>
                            <div id="preview-container">
                                <p id="file-name" className="text-sm text-gray-600 mt-2"></p>
                            </div>
                        </div>
                    }
                />*/}
            </div>
        </div>
    );
};

export default Media;
